import { takeLatest, put } from 'redux-saga/effects';
import { fetchTxnOppValuations, setSelectedAuctionTxnOppValuations, appNotify } from 'store/actions';
import { getWithToken } from 'api/network';

export function* getTxnOppValuationsSaga() {
  yield takeLatest(fetchTxnOppValuations, function* ({ payload }) {
    const { txnOppId, onSuccess } = payload;
    try {
      const res = yield getWithToken(`/api/underwrite/prop/${txnOppId}/clientTxnOppValuations`);
      const data = yield res.json();
      yield put(setSelectedAuctionTxnOppValuations({ txnOppId, valuations: data }));
      onSuccess && onSuccess();
    } catch (error) {
      yield put(appNotify(error.message, 'error'));
    }
  });
}